import React from 'react'

const ContactFieldSkeleton = () => (
  <div
    className={
      'flex w-full flex-col flex-wrap justify-center gap-y-5 lg:-ml-5 lg:w-[calc(100%+20px)] lg:flex-row'
    }
  >
    {Array.from(Array(12).keys()).map((el, index) => (
      <div className={'w-full sm:basis-1/2 lg:pl-5'} key={index}>
        <div className="bg-skeleton-primary my-3 w-full animate-pulse rounded-lg py-3 text-transparent">
          .
        </div>
      </div>
    ))}
  </div>
)

export default ContactFieldSkeleton
